import config from 'config'
import React, { Component, Suspense } from 'react'
import { Router, Route, Switch } from 'react-router-dom'
import { connect } from 'react-redux'
import { ReactComponent as Sprite } from 'srcReact/assets/symbol/sprite.svg'
import history from 'srcReact/helpers/history'
import {
  setCookie,
  isMobileScreen,
  isTabletScreen,
  urlSearchParams,
  getDescryptedMedia,
  isNative,
  isWideScreen,
  getCookie
} from 'srcReact/helpers/utils'
import { isUserAuthorized } from 'srcReact/helpers/userHelper'
import { Manager, BREAKPOINT_CHANGE } from 'srcReact/helpers/events'
import GDPRCookieConsent from 'srcReact/GDPRCookieConsent'
import UpdateApp from 'srcReact/Pages/UpdateApp'
import { PrivateRoute, AdminRoute, commonActions, PageTestContainer } from 'srcReact/components'
import { LoginContainer, loginActions } from 'srcReact/LoginPage'
import InviteWorkplaceMembersToEvent from 'srcReact/Mixr/InviteWorkplaceMembersToEvent'
import DecryptFile from 'srcReact/DecryptFile'
import { appConstantSettings } from 'srcReact/appConstantSettings'
import { CreateOrganization, OrganizationTerms, organizationActions } from 'srcReact/OrganizationPage'
import { CreateWorkplace, CreateOrJoin } from 'srcReact/WorkplacePage'
import InvitationStep from 'srcReact/WorkplacePage/InvitationStep'
import { WorkplaceSettingsPage } from 'srcReact/WorkplaceSettingsPage'
import {
  PricingPageContainer,
  PricingNonProfitPageContainer,
  CallbackCheckoutPageContainer,
  CallbackCheckoutEditPageContainer,
  CallbackPaymentMethodPageContainer
} from 'srcReact/SubscriptionPage'
import ContactUs from 'srcReact/Pages/Support/ContactUs'
import TicketDetails from 'srcReact/Pages/Support/TicketDetails'
import Tickets from 'srcReact/Pages/Support/Tickets'
import { MemberDirectoryContainer } from 'srcReact/OrganizationPage/MemberDirectoryContainer'
import { alertActions } from 'srcReact/Alert'
import { ErrorPageUser, ErrorPageOwner } from 'srcReact/BillingPaymentErrorPages'
import { MessengerPageContainer } from 'srcReact/MessengerPage'
import Settings from 'srcReact/Settings'
import Notifications from 'srcReact/Settings'
import MyProfile from 'srcReact/MyProfile'
import CommunityGuidelines from 'srcReact/CommunityGuidelines'
import TermsOfServices from 'srcReact/TermsOfServices'
import PrivacyPolicy from 'srcReact/PrivacyPolicy'
import CalendarPage from 'srcReact/CalendarPage'
import { ModerationReportPage } from 'srcReact/ModerationReportPage'
import { OrganizationSettingsPage } from 'srcReact/OrganizationSettingsPage'
import { SearchPageContainer } from 'srcReact/SearchPage'
import { MyHomePageContainer } from 'srcReact/MyHomePage'
import { DiscoverPageContainer } from 'srcReact/DiscoverPage'
import { GroupHomePageContainer } from 'srcReact/GroupHomePage'
import { FeedPageContainer } from 'srcReact/FeedPage'
import { NotificationPageContainer } from 'srcReact/NotificationPage'
import { SignupPage } from 'srcReact/SignupPage'
import ResetPasswordPage from 'srcReact/ResetPasswordPage'
import CreateUpdateMixR from 'srcReact/Mixr/CreateUpdateMixr'
import CreateUpdateGroup from 'srcReact/GroupPage/CreateUpdateGroup'
import MixrHome from 'srcReact/Mixr/MixrHome'
import { withTranslation } from 'react-i18next'
import Spinner from 'srcReact/components/common2/Spinner'
import Banner from 'srcReact/components/common2/Banner'
import dayjs from 'dayjs'
import 'dayjs/locale/fr'
import 'dayjs/locale/en'
import { NotEligibleSSOUser } from 'srcReact/LoginPage/NotEligibleSSOUser'
import InetumPricing from 'srcReact/SubscriptionPage/InetumPricing'
import { dateDiffInHours } from 'srcReact/helpers/datetimeHelper'
import { ErrorBoundary } from 'react-error-boundary'
import ErrorFallback from 'srcReact/ErrorPages/ErrorFallback'
import ServerErrorPage from 'srcReact/ErrorPages/ServerErrorPage'
import PageNotFound from 'srcReact/ErrorPages/PageNotFound'
import InviteWorkplaceMembersToGroup from 'srcReact/GroupHomePage/InviteWorkplaceMembersToGroup'
import SaveConnection from 'srcReact/SaveConnection'
import Dashboard from 'srcReact/Dashboard'
import { authenticationActions } from 'srcReact/redux/actions/authentication'
import AuthorizeExternalApp from 'srcReact/LoginPage/AuthorizeExternalApp'
import FeedContentPage from 'srcReact/components/common2/FeedsTabContent/components/FeedContentPage'
import { getWorkplaceIds } from 'srcReact/helpers/workplaceHelper'
import GeneralGroupCreated from 'srcReact/WorkplacePage/GeneralGroupCreated'
import TutorialV2 from 'srcReact/components/popinsContent/TutorialV2'
import QuickMessenger from 'srcReact/MessengerPage/components/QuickMessenger'
import MyInvites from 'srcReact/ProfilePage/MyInvites'
import { profileActions } from 'srcReact/ProfilePage'

class App extends Component {
  constructor(props) {
    super(props)
    this.state = {
      intervalBadgeId: 0,
      showSecondOnboarding: false
    }

    // The timer has been reduced to 3 seconds to display loader on the native app for pending post count
    let timer = props.isNative ? 3000 : 10000

    if (props.loggedIn) {
      this.getBadgeCount()
      this.setState({ intervalBadgeId: setInterval(this.getBadgeCount, timer) }) // 10 seconds
    }

    // Native App Authentication
    if (props.isNative) {
      const location = history.location.pathname
      const homehead = location.match(
        /communities-at-work|pricing|landing|contact-us|press|blog|terms-of-services|privacy-policy/
      )
      // remove force update
      props.getAppStoreVersions()
      const lastUpdateAppDate = JSON.parse(localStorage.getItem('last_update_app_date'))
      const diffs = dateDiffInHours(dayjs(), lastUpdateAppDate)
      if (!homehead) {
        if (diffs >= 24 || lastUpdateAppDate === null) {
          props.setUserAppVersion(urlSearchParams('app_version'))
          props.checkNativeUserAppVersion(urlSearchParams('app_version'))
        }
      }

      if (urlSearchParams(appConstantSettings.LANG_COOKIE_NAME)) {
        const currentLanguage = urlSearchParams(appConstantSettings.LANG_COOKIE_NAME)
        dayjs.locale(currentLanguage)
        localStorage.setItem('current_lang', currentLanguage)
        setCookie(appConstantSettings.LANG_COOKIE_NAME, currentLanguage, appConstantSettings.LANG_COOKIE_EXP_DAYS)
      }

      const gdpr = localStorage.getItem('gdpr')
      if (gdpr) setCookie('gdpr', JSON.stringify(gdpr), 365)

      if (
        (urlSearchParams('access_token') && urlSearchParams('user')) ||
        (urlSearchParams('user_token') && urlSearchParams('user')) ||
        (urlSearchParams('uaccess_token') && urlSearchParams('user'))
      ) {
        const keepMeLoggedIn = urlSearchParams('keep_me_logged_in') || 365
        setCookie('usr_logged', 1, keepMeLoggedIn)
        const userToken =
          urlSearchParams('access_token') || urlSearchParams('user_token') || urlSearchParams('uaccess_token')
        setCookie('uaccess_token', userToken, keepMeLoggedIn)
        const user = urlSearchParams('user')
        localStorage.setItem('user', user)
        const currentOrganization = urlSearchParams('current_organization')
        const organizationId = urlSearchParams('organization_id')
        const workplaceIds = urlSearchParams('id_workplace')
        if (currentOrganization) {
          setCookie('current_organization', currentOrganization, 365)
          localStorage.setItem('current_organization', currentOrganization)
          const current_organization = JSON.parse(currentOrganization)
          setCookie('s3Url', current_organization.info.s3Url, 365)
          props.setNativeCurrentOrganization(current_organization)
        }
        if (organizationId) {
          setCookie('organization_id', organizationId, 365)
          setCookie('current_organization_id', organizationId, 365)
          props.getHeaderInfo(organizationId, 'subscription,sidebar,popup_display', 'v2_migration')
          props.getOrganizationList(appConstantSettings.ORG_LIST_QTY)
        }
        if (workplaceIds) {
          setCookie('id_workplace', workplaceIds, 365)
        }
      }
    }
  }

  oneSignalInit() {
    window.OneSignal = window.OneSignal || []
    if (this.props.user) {
      const currentUserId = this.props.user.id
      const currentUsername = this.props.user.firstname + ' ' + this.props.user.lastname
      OneSignal.push(function () {
        OneSignal.init({
          appId: config.pushId
        })

        OneSignal.getTags(function (tags) {
          if (tags['ID'] != currentUserId) {
            OneSignal.sendTag('ID', currentUserId)
            OneSignal.sendTag('User name', currentUsername)
          }
        })

        let ios_device = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream ? 1 : 0
        if (ios_device == 0 && typeof OneSignal !== 'undefined' && OneSignal !== undefined) {
          OneSignal.on('notificationPermissionChange', function (permissionChange) {
            var currentPermission = permissionChange.to
            if (currentPermission == 'denied') {
              OneSignal.deleteTag('ID')
              OneSignal.deleteTag('User name')
              this.deleteDataSDKDB()
            }
          })
        }
      })
    } else {
      OneSignal.push(function () {
        OneSignal.deleteTag('ID')
        OneSignal.deleteTag('User name')
      })
    }
  }

  deleteDataSDKDB() {
    window.indexedDB = window.indexedDB || window.mozIndexedDB || window.webkitIndexedDB || window.msIndexedDB
    try {
      window.indexedDB.deleteDatabase('ONE_SIGNAL_SDK_DB')
    } catch (e) {
      console.log(e)
    }
    // Delete Local Storage
    let notToClean = ['user', 'current_organization', 'organization_list']
    for (let key in localStorage) {
      if (notToClean.includes(key)) {
        continue
      }
      localStorage.removeItem(key)
    }
    // Delete Session Storage
    sessionStorage.clear()
  }

  getLocation = () => {
    if (!this.props.isNative) {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            let locationData = {
              latitude: position.coords.latitude,
              longitude: position.coords.longitude
            }

            this.props.setUserLocation(locationData)
          }, //do nothing on success
          (positionError) => {
            //code 1= User denied Geolocation
            if (positionError.code === 1) {
              this.props.getUserIPAddress()
            }
          }
        )
      } else {
        this.props.getUserIPAddress()
      }
    } else {
      this.props.getUserIPAddress()
    }
  }

  componentDidMount() {
    window.addEventListener('orientationchange', this.handleOrientationChange)
    if (!this.props.isNative) {
      const { current_organization, user } = this.props
      // OneSignal init
      this.oneSignalInit()

      this.handleWindowSizeChange()

      Manager.subscribe(BREAKPOINT_CHANGE, this.handleWindowSizeChange)
      history.listen((location, action) => {
        // clear alert on location change
        this.props.clearAlerts()
      })

      //this call is to get country name for specific country pricing

      if (isUserAuthorized()) {
        this.props.getInvites(1)
        this.props.getOrganizationList(appConstantSettings.ORG_LIST_QTY)

        // if (!user.picture) {
        //   const { profile_picture, is_original, original_tag, mime_type } = user
        //   getDescryptedMedia(profile_picture, is_original, original_tag, mime_type, user.id, true).then((data) => {
        //     this.props.setLoginPicture(data.img)
        //   })
        // }

        //location permission
        const storedLocation = getCookie('user_location')
        if (storedLocation === null) {
          if (this.props.userLocation.latitude !== 0 && this.props.userLocation.longitude !== 0) {
            {
              this.getLocation()
            }
          }
        } else {
          const parseLocation = JSON.parse(storedLocation)
          this.props.setUserLocation(parseLocation)
        }
      } else {
        this.getLocation()
      }
    }
    let serverAccessToken = getCookie('saccess_token')
    if (serverAccessToken === null) {
      this.props.getServerAccessToken(config.grantType, config.clientId, config.clientSecret)
    }

    if (this.props.loggedIn && localStorage.getItem('showSecondOnboarding')) {
      this.setState({ showSecondOnboarding: true })
    }
  }

  componentWillUnmount() {
    window.removeEventListener('orientationchange', this.handleOrientationChange)
    if (!this.props.isNative) {
      Manager.unsubscribe(BREAKPOINT_CHANGE, this.handleWindowSizeChange)
      clearInterval(this.state.intervalBadgeId)
    }
  }

  hasCurrentOrganization = () => {
    const { current_organization } = this.props
    return current_organization && current_organization.info && current_organization.info.id > 0
  }

  getBadgeCount = () => {
    const { header, current_organization, getHeaderInfo, newsFeedId, isNative, user } = this.props

    // pass news feed id in header call, to get update if any feed(with files) is done with processing
    let idNewsfeed = -1
    if (location.pathname.includes('/0/home/event/') || location.pathname.includes('/0/home/group/')) {
      idNewsfeed = newsFeedId
    } else if (location.pathname.includes('0/feed')) {
      idNewsfeed = 0
    }
    //call api for counts only if user is subscribed to any plan
    if (header && header.subscription && header.subscription.plan && this.hasCurrentOrganization()) {
      const nativeScreens = ['/0/home/event', '/0/home/group', '/0/feed', '/0/myhome']
      if (!isNative || (isNative && nativeScreens.some((sub) => location.pathname.includes(sub)))) {
        getHeaderInfo(current_organization.info.id, idNewsfeed > -1 ? 'newsfeed,sidebar' : 'sidebar', '', 0, idNewsfeed)
      }

      //call location api if user_location cookie is expired
      const storedLocation = getCookie('user_location')
      if (storedLocation === null) {
        this.getLocation()
      }
    }
  }

  /**
   * Check if the current location pathname includes a string from URLList
   * @param URLList
   */
  isExistInURL = (URLList = []) => {
    return URLList.filter((URL) => location.pathname.includes(URL))
  }

  redirectPricing = () => {
    history.push('/0/pricing')
  }

  redirectCreateWorkplace = (orgaId) => {
    history.push(`/0/create-workplace?organization_id=${orgaId}`)
  }

  handleWindowSizeChange = () => {
    this.props.setIsDesktop(isWideScreen())
    this.props.setIsTablet(isTabletScreen())
    this.props.setIsMobile(isMobileScreen())
    this.props.setIsNative(isNative())
  }

  handleOrientationChange = () => {
    switch (window.orientation) {
      case -90:
      case 90:
        this.props.setIsDesktop(isWideScreen())
        this.props.setIsMobile(false)
        break
      default:
        this.props.setIsMobile(isMobileScreen())
        this.props.setIsDesktop(false)
        break
    }
  }

  render() {
    const { isNative, isMobile, isDesktop, loggedIn, t, enableGDPRCookie, current_organization } = this.props
    const search = history.location.search
    const location = history.location.pathname
    // const homehead = location.match(/pricing|landing|contact-us|press/)
    const fluidContainer = location.match(
      /0\/v1\/workplace\/settings|workplace\/members|workplace\/leadership-team|workplace\/new-invites|workplace\/manage-invites|workplace\/manage-invites-page|workplace\/edit/
    )
    const authPage = location.match(/auth|signup|reset-password|sign-in\/sso-return/)

    let classContainer = `${fluidContainer && 'container-fluid'}`

    /* New user invited by email to join a workplace */
    let isNewUserInvitedByEmail = ''
    const inviteUrl = `${config.webUrl}${location}${search}`
    // Use a regular expression to extract the email value from the URL
    const emailRegex = /\/0\/your-invites\?email=([^&]+)&step=([^&]+)/
    const match = inviteUrl?.match(emailRegex)
    // Check if there is a match and extract the email value
    if (match && match[1] && match[2]) {
      isNewUserInvitedByEmail = `?email=${match[1]}&step=${match[2]}`
    }

    const workplaceIds = getWorkplaceIds(current_organization)

    return (
      <React.Fragment>
        <Suspense fallback={<div>{t('group.index.loading')}</div>}>
          <ErrorBoundary FallbackComponent={() => <ErrorFallback title={t('errorPage.clientTitle')} />}>
            <div style={{ display: 'none' }}>
              <Sprite />
            </div>
            <React.Fragment>
              {loggedIn && this.state.showSecondOnboarding && localStorage.getItem('showSecondOnboarding') && (
                <TutorialV2 onboardingType='second_time' />
              )}
              {/* if isNative is false or if isNative is true and enableGDPRCookie is equal to 1 and it ensures that authPage is false */}
              {/* This is temporary change for demo. It should uncommented after sometime */}
              {/* {(!isNative || (isNative && enableGDPRCookie == 1)) && <GDPRCookieConsent />} */}
              <Banner />
              <div className={classContainer}>
                {/* For desktop sidebar */}
                {/* {loggedIn && withSidebar && !isMobile && !isNative && <SideBarMain />} */}
                {/* For mobile navigation bar */}
                {/* {loggedIn && withSidebarMobile && isMobile && !isNative && <SideBarMain />} */}
                <Router history={history}>
                  <Switch>
                    <Route exact path='/auth'>
                      <LoginContainer />
                    </Route>
                    <Route exact path='/auth/:app'>
                      <AuthorizeExternalApp />
                    </Route>
                    <Route exact path='/0/signup'>
                      <SignupPage />
                    </Route>
                    <Route exact path='/0/reset-password'>
                      <ResetPasswordPage />
                    </Route>
                    <Route path='/contact-us'>
                      <ContactUs />
                    </Route>
                    <Route path='/0/error-user'>
                      <ErrorPageUser />
                    </Route>
                    <Route path='/0/error-owner'>
                      <ErrorPageOwner />
                    </Route>
                    <Route path='/0/create-or-join-workplace'>
                      <CreateOrJoin />
                    </Route>
                    <Route path='/0/how-update-native-application'>
                      <UpdateApp />
                    </Route>
                    <PrivateRoute path='/0/pricing/intm' component={InetumPricing} />
                    <PrivateRoute exact path='/0/support' component={ContactUs} />
                    <PrivateRoute exact path='/0/support/tickets/:id' component={TicketDetails} />
                    <PrivateRoute exact path='/0/support/tickets' component={Tickets} />
                    <PrivateRoute path='/0/moderation' component={ModerationReportPage} />
                    <PrivateRoute path='/0/search' component={SearchPageContainer} />
                    <PrivateRoute path='/0/feed' component={FeedPageContainer} />
                    <PrivateRoute path='/0/notifications' component={NotificationPageContainer} />
                    <PrivateRoute path='/0/home/group/:groupId' component={GroupHomePageContainer} />
                    {/* <PrivateRoute path='/0/myhome' component={MyHomePageContainer} redirectUrl='/communities-at-work' /> */}
                    <PrivateRoute
                      path='/0/myhome'
                      component={MyHomePageContainer}
                      redirectUrl='https://community.mixr.net/'
                    />

                    <PrivateRoute path='/0/discover' component={DiscoverPageContainer} />
                    <PrivateRoute path='/0/create-workplace' component={CreateWorkplace} />
                    <PrivateRoute
                      path='/0/workplaces'
                      redirectUrl={`${config.webUrl}${
                        workplaceIds?.length > 0 ? `/0/workplace/settings/${workplaceIds.split(',')[0]}` : `/0/myhome`
                      }`}
                    />
                    <PrivateRoute path='/0/workplace/settings/:workplaceId' component={WorkplaceSettingsPage} />
                    <PrivateRoute path='/0/workplace/invite-members/:workplace_id' component={InvitationStep} />
                    <PrivateRoute path='/0/general_group_created' component={GeneralGroupCreated} />

                    <PrivateRoute path='/0/create-organization' component={CreateOrganization} />
                    <PrivateRoute path='/0/organization/settings' component={OrganizationSettingsPage} />

                    <PrivateRoute path='/0/group/:group_id/invite-members' component={InviteWorkplaceMembersToGroup} />

                    <PrivateRoute path='/0/event/:event_id/invite-members' component={InviteWorkplaceMembersToEvent} />
                    <PrivateRoute path='/0/dashboard/group/:group_id' component={Dashboard} />
                    <PrivateRoute path='/0/dashboard/workplace/:workplace_id' component={Dashboard} />

                    <PrivateRoute
                      path='/0/your-invites'
                      redirectUrl={isNewUserInvitedByEmail ? '/0/signup' : '/auth'}
                      queryParam={
                        isNewUserInvitedByEmail
                          ? isNewUserInvitedByEmail
                          : '?ruaa=' + encodeURI(`${config.webUrl}/0/your-invites`)
                      }
                      component={MyInvites}
                    />
                    <PrivateRoute path='/0/callback-checkout' component={CallbackCheckoutPageContainer} />
                    <PrivateRoute path='/0/callback-checkout-edit' component={CallbackCheckoutEditPageContainer} />
                    <PrivateRoute path='/0/callback-payment-method' component={CallbackPaymentMethodPageContainer} />
                    <PrivateRoute path='/0/member-directory' component={MemberDirectoryContainer} />
                    <PrivateRoute path='/0/organization-terms-of-services' component={OrganizationTerms} />
                    <PrivateRoute
                      key='create-general-group'
                      path='/0/create-group/:workplaceId'
                      component={CreateUpdateGroup}
                    />
                    <PrivateRoute key='create-group' path='/0/create-group' component={CreateUpdateGroup} />
                    <PrivateRoute key='edit-group' path='/0/edit-group/:groupId' component={CreateUpdateGroup} />
                    <PrivateRoute key='create-mixr' path='/0/create-mixr' component={CreateUpdateMixR} />
                    <PrivateRoute
                      key='create-mixr-from-group'
                      path='/0/:groupId/create-mixr'
                      component={CreateUpdateMixR}
                    />
                    <PrivateRoute key='edit-mixr' path='/0/:groupId/edit-mixr/:mixrId' component={CreateUpdateMixR} />

                    <PrivateRoute path='/0/messenger' component={MessengerPageContainer} />
                    <PrivateRoute path='/0/settings/account' component={Settings} />
                    <PrivateRoute path='/0/settings/notifications' component={Notifications} />
                    <PrivateRoute path='/0/settings/integrations' component={Settings} />
                    <PrivateRoute path='/0/settings/organization-documents' component={Settings} />
                    <PrivateRoute path='/0/settings/integrations' component={Settings} />
                    <PrivateRoute path='/0/profile/:userId' component={MyProfile} />
                    <PrivateRoute path='/0/home/event/:mixrId' component={MixrHome} />
                    <PrivateRoute path='/0/feed-content/:entity/:entityId/:feedId' component={FeedContentPage} />
                    <PrivateRoute path='/0/calendar' component={CalendarPage} />
                    <PrivateRoute path='/0/gcalAddEvent' component={SaveConnection} />
                    <PrivateRoute path='/0/mcalAddEvent' component={SaveConnection} />
                    <PrivateRoute path='/0/zoomConnect' component={SaveConnection} />
                    <Route path='/organization-terms-of-services'>
                      <OrganizationTerms />
                    </Route>
                    <Route path='/0/sign-in/sso-return'>
                      <NotEligibleSSOUser />
                    </Route>
                    <Route exact path='/0/pricing'>
                      <PricingPageContainer />
                    </Route>
                    <Route exact path='/0/pricing-non-profit'>
                      <PricingNonProfitPageContainer />
                    </Route>
                    <Route exact path='/0/community-guidelines'>
                      <CommunityGuidelines />
                    </Route>
                    <Route exact path='/0/terms-of-services/'>
                      <TermsOfServices />
                    </Route>
                    <Route exact path='/0/privacy-policy'>
                      <PrivacyPolicy />
                    </Route>
                    <Route
                      exact
                      path='/communities-at-work'
                      component={() => {
                        // window.location.href = config.webUrl + '/communities-at-work'
                        window.location.href = 'https://community.mixr.net/'
                        return null
                      }}
                    />
                    <AdminRoute exact path='/0/admin/decrypt-file' component={DecryptFile} />

                    <Route exact path='/0/page-test'>
                      <PageTestContainer />
                    </Route>
                    <Route
                      exact
                      path='/registration'
                      component={(props) => {
                        window.location.assign(`${config.webUrl}/registration/${props.location.state.queryParam}`)
                        return <Spinner />
                      }}
                    />

                    <Route
                      exact
                      path='/'
                      component={() => {
                        window.location.assign(config.webUrl)
                        return <Spinner />
                      }}
                    />
                    <Route exact path='/0/internal-error'>
                      <ServerErrorPage />
                    </Route>
                    <Route path='*'>
                      <PageNotFound />
                    </Route>
                  </Switch>
                </Router>
                {isDesktop && loggedIn && !history.location.pathname.match(/messenger/) && <QuickMessenger />}
              </div>
            </React.Fragment>
          </ErrorBoundary>
        </Suspense>
      </React.Fragment>
    )
  }
}

function mapStateToProps(state) {
  const { alert, login, common, organization, commonNewsfeed } = state
  const { user, loggedIn } = login
  const { isNative, isMobile, isDesktop, userLocation, enableGDPRCookie } = common
  const { current_organization, organization_list, workplace_list, header } = organization
  const { newsFeedId } = commonNewsfeed
  return {
    alert,
    user,
    isNative,
    isMobile,
    loggedIn,
    current_organization,
    organization_list,
    workplace_list,
    userLocation,
    header,
    enableGDPRCookie,
    newsFeedId,
    isDesktop
  }
}

const actionCreators = {
  clearAlerts: alertActions.clear,
  setIsMobile: commonActions.setIsMobile,
  setIsTablet: commonActions.setIsTablet,
  setIsNative: commonActions.setIsNative,
  setIsDesktop: commonActions.setIsDesktop,
  getOrganizationInfo: organizationActions.getOrganizationInfo,
  getInvites: profileActions.getInvites,
  getOrganizationList: organizationActions.getByUser,
  setUserLocation: commonActions.setUserLocation,
  setUserAppVersion: commonActions.setUserAppVersion,
  checkNativeUserAppVersion: commonActions.checkNativeUserAppVersion,
  loginUser: loginActions.loginUser,
  getUserIPAddress: commonActions.getUserIPAddress,
  getHeaderInfo: organizationActions.getHeaderInfo,
  getAppStoreVersions: commonActions.getAppStoreVersions,
  setNativeCurrentOrganization: organizationActions.setNativeCurrentOrganization,
  getServerAccessToken: authenticationActions.getServerAccessToken
}

const ExtendedComponent = withTranslation('common')(App)
const connectedApp = connect(mapStateToProps, actionCreators)(ExtendedComponent)
export { connectedApp as App }
